<template>
  <v-container grid-list-xl>
    <v-tabs fixed-tabs background-color="indigo" dark v-model="contentTabs" class="mb-8">
      <v-tab>
        Support Functions
      </v-tab>
      <v-tab>
        Customer Success
      </v-tab>
    </v-tabs>

    <div v-if="contentTabs === 1">

      <v-layout row>
        <v-flex sm2 md2 background-color="indigo" dark>
          <div background-color="indigo" color="indigo">
            <v-layout row>
              <v-flex md12>

                <v-flex>
                  <p class="title">
                    Choose Store
                  </p>
                  <v-autocomplete clearable :items="shops" v-model="paulSearch" label="Choose Store" item-text="name"
                    item-value="name"></v-autocomplete>
                </v-flex>

                <v-flex>
                  <p class="title">
                    Opinew plan:
                  </p>
                  <v-autocomplete clearable multiple @change="chosenOpinewPlanHandler" :items="plans"
                    v-model="chosenOpinewPlan" label="Choose Opinew Plan" item-text="name"
                    item-value="id"></v-autocomplete>
                </v-flex>

                <v-flex>
                  <p class="title">
                    Shopify plan:
                  </p>
                  <v-autocomplete clearable multiple @change="chosenShopifyPlanHandler" :items="shopifyPlans"
                    v-model="chosenShopifyPlan" label="Choose Shopify Plan" item-text="label"
                    item-value="name"></v-autocomplete>
                </v-flex>


                <v-layout row>
                  <v-flex md9>
                    <p class="title">
                      Revenue:
                    </p>
                    <v-autocomplete clearable @change="chosenMrrOptionHandler" :items="mrr_options"
                      v-model="chosenMrrOption" label="Choose MMR Option" item-text="label"
                      item-value="id"></v-autocomplete>
                  </v-flex>

                  <v-flex md3>
                    <input type="number" min="0" step="1" v-model="mrrValue" placeholder="Enter value" item-text="label"
                      item-value="id" return-object=""
                      v-autowidth="{ maxWidth: '30px', minWidth: '10px', comfortZone: 0 }" />
                  </v-flex>
                </v-layout>

                <v-flex>
                  <p class="title">
                    Active Integrations:
                  </p>
                  <v-autocomplete clearable multiple @change="chosenIntegrationsHandler" :items="integrations"
                    v-model="filteredIntegration" label="Choose Integrations" item-text="name"
                    item-value="label"></v-autocomplete>
                </v-flex>

                <v-layout row>
                  <v-flex md9>
                    <p class="title">
                      Plan price:
                    </p>
                    <v-autocomplete clearable @change="chosenPriceOptionHandler" :items="price_options"
                      v-model="chosenPriceOption" label="Choose Price Option" item-text="label"
                      item-value="id"></v-autocomplete>
                  </v-flex>

                  <v-flex md3>
                    <input type="number" min="0" step="1" v-model="chosenPrice" placeholder="Enter value"
                      item-text="label" item-value="id" return-object=""
                      v-autowidth="{ maxWidth: '30px', minWidth: '10px', comfortZone: 0 }" />
                  </v-flex>
                </v-layout>

                <DashboardButton @click.native.stop=generatePaulTable class="indigo">Search
                </DashboardButton>
                <br>

                <DashboardButton @click.native.stop="filterNameDialog = true" class="indigo">Save Filter
                </DashboardButton>

              </v-flex>
            </v-layout>
          </div>
        </v-flex>

        <v-flex sm9 md9 background-color="indigo">
          <v-layout row>
            <v-flex md12>
              <v-layout row>
                <v-flex md3 style="background-color: #3f51b5;">
                  <h3 style="color: #FFFFFF!important;">Chosen filters:</h3>
                  <p style="color: #FFFFFF;">
                  <ul>
                    <div v-for="(value, key) in activeFilter ">
                      <b>{{ key }} :</b> {{ value }}
                    </div>
                  </ul>
                  </p>
                </v-flex>
                <v-flex md1></v-flex>
                <v-flex md3 style="background-color: #FFFFFF; border:solid;">

                  <DashboardButton @click.native.stop=getFilters class="indigo">Reload Filters
                  </DashboardButton>
                  <!-- {{ this.savedFilters }} -->
                  </br>
                  <p class="title">
                    Load Filter:
                  </p>
                  <v-autocomplete clearable @change="chosenFilterHandler" :items="savedFilters" v-model="filter"
                    label="Choose Filter" item-text="name" item-value="name"></v-autocomplete>


                  <DashboardButton @click.native.stop=loadFilter class="indigo">Load
                  </DashboardButton>


                  <v-row justify="center">
                    <v-dialog v-model="filterNameDialog" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Filter Name</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>

                            <input type="text" v-model="filterName" placeholder="Enter name" return-object=""
                              v-autowidth="{ maxWidth: '30px', minWidth: '10px', comfortZone: 0 }" />
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="filterNameDialog = false">Cancel</v-btn>

                          <v-btn color="blue" text @click="saveFilter()">Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>



                  <v-row justify="center">
                    <v-dialog v-model="newWorkingGroup" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Working Group</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <ul>
                                <input type="text" v-model="workingGroupName" placeholder="Enter name" item-text="label"
                                  item-value="id" return-object=""
                                  v-autowidth="{ maxWidth: '30px', minWidth: '10px', comfortZone: 0 }" />

                              </ul>
                              <ul>
                                <input type="text" v-model="workingGroupDescription" placeholder="Enter description"
                                  item-text="label" item-value="id" return-object=""
                                  v-autowidth="{ maxWidth: '30px', minWidth: '10px', comfortZone: 0 }" />
                              </ul>

                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="createWorkingGroup">Create</v-btn>
                          <v-btn color="blue" text @click="newWorkingGroup = false">Close</v-btn>

                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </v-flex>
                <v-flex md1></v-flex>


                <v-flex md4 style="background-color: #FFFFFF; border:solid;">

                  <DashboardButton @click.native.stop=loadWorkingGroups class="indigo">Reload Working Groups
                  </DashboardButton>
                  <v-flex>
                    <p class="title">
                      Working group
                    </p>

                    <DashboardButton @click.native.prevent="newWorkingGroup = true" class="indigo">New Working Group
                    </DashboardButton>


                    <v-autocomplete clearable @change="chosenWorkingGroupHandler" :items="workingGroups"
                      v-model="chosenworkingGroup" label="Choose Working group" item-text="name"
                      item-value="id"></v-autocomplete>
                  </v-flex>



                  <!-- <DashboardButton @click.native.stop=getWorkingGroupId class="indigo">Load Working Group
                  </DashboardButton> -->

                  <DashboardButton @click.native.stop=getWorkingGroup class="indigo">Load Stores
                  </DashboardButton>


                </v-flex>
              </v-layout>
              <p></p>

              <v-data-table dark :headers="headersCustomer" auto-select-first="false" :items="paulShops" item-key="id"
                class="elevation-1" :sort-by.sync="sortBy" :sort-desc.sync="descendingValue"
                :server-items-length="totalShopsCount" @update:items-per-page="pageCountHandler" :footer-props="{
      'items-per-page-options': rowsPerPageItems,
    }">

                <template v-slot:[`item.name`]="{ item }">
                  <p class="table-link" @click="shopBrowse(item.id)">{{ item.name }}</p>
                </template>



                <template v-slot:[`item.activePlan`]="{ item }">
                  <div class="text-capitalize">
                    {{ item.activePlan }}
                  </div>
                </template>

                <template v-slot:[`item.planPrice`]="{ item }">
                  ${{ item.planPrice }}
                </template>

                <template v-slot:[`item.shopifyPlan`]="{ item }">
                  <div class="text-capitalize">
                    {{ item.shopifyPlan }}
                  </div>
                </template>


                <template v-slot:[`item.opwMrr`]="{ item }">
                  <div class="text-capitalize">
                    {{ item.opwMrr }}
                  </div>
                </template>



                <template v-slot:[`item.totalOrders`]="{ item }">
                  <div class="text-capitalize">
                    {{ item.totalOrders }}
                  </div>
                </template>


                <template v-slot:[`item.shopCreatedAt`]="{ item }">
                  {{ dateFormated(item.createdAt) }}
                </template>


                <template v-slot:[`item.reviewNumber`]="{ item }">
                  <div class="text-capitalize">
                    {{ item.reviewNumber }}
                  </div>
                </template>

                <template v-slot:[`item.lifetimeSpend`]="{ item }">
                  ${{ lifetimeSpendHandler(item.createdAt, item.planPrice) }}
                </template>

                <template v-slot:[`item.mrr`]="{ item }">
                  ${{ item.mrr }}
                </template>

                <template v-slot:item.details="{ item }">

                  <v-btn fab dark x-small color="#000080" size="sm" @click.native.stop="showPaulTableEntry(item.id)"
                    style="position:relative; bottom:12px;">
                    <v-icon dark>mdi-information</v-icon>
                  </v-btn>

                  <v-row justify="center">
                    <v-dialog v-model="shopDetails" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Shop Details</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <ul>
                                <div v-for="(value, key) in paulSelected ">
                                  <h3><b>{{ (key.charAt(0).toUpperCase() +
      key.slice(1)).split(/(?=[A-Z])/).join(' ') }}
                                      :</b></h3>
                                  <ul style="list-style-type: none;">
                                    <div v-for="(v, k) in value ">
                                      <li>
                                        <b>{{ (k.charAt(0).toUpperCase() +
      k.slice(1)).split(/(?=[A-Z])/).join(' ')
                                          }}
                                          :</b>
                                        {{ v }}
                                      </li>
                                    </div>
                                  </ul>
                                  <br>
                                </div>
                              </ul>

                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="shopDetails = false">Close</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>


                <template v-slot:item.add="{ item }">
                  <v-btn fab dark x-small color="#000080" size="sm" @click.native.stop="addToWorkingGroup(item.id)">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>


                <template v-slot:item.remove="{ item }">
                  <v-btn fab dark x-small color="#000080" size="sm"
                    @click.native.stop="deleteFromWorkingGroup(item.id)">
                    <v-icon dark>mdi-minus</v-icon>
                  </v-btn>

                </template>



                <!-- <template>
                  <v-row justify="center">
                    <v-dialog v-model="importDialog" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Shop details</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="importChange" label="Review imports to set" persistent-hint
                                  required></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="importDialog = false">Close</v-btn>
                          <v-btn color="blue" @click.native.prevent="
                            changeReviewImportQuota(3, importChange)
                            ">Change</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template> -->

              </v-data-table>


            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

    </div>



















    <div v-else>
      <v-layout row>
        <v-flex md12>
          <v-layout row>
            <v-flex md4>
              <v-autocomplete @change="shopChange" :items="shops" v-model="shop" :search-input.sync="search"
                label="Choose Store" item-text="name" item-value="id" return-object=""></v-autocomplete>
            </v-flex>
            <v-flex md4>
              <DashboardButton @click.native.prevent="shopBrowse()" class="orange" :disabled="methodsEnabled == false">
                Log
                into shop dashboard</DashboardButton>
            </v-flex>
            <v-flex md4>
              <DashboardButton @click.native.prevent="shopThemeEditor()" class="green"
                :disabled="methodsEnabled == false">
                Edit theme code</DashboardButton>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex sm4 md4>
          <v-layout row>
            <v-flex md12>
              <p class="title">Store ID: {{ currentStore }}</p>
              <p class="title">Store name: {{ storeName }}</p>
              <p class="title" v-if="trialCreation">
                Shop creation date:
                <span>{{ trialCreation.toDateString() }}</span>
              </p>
              <p class="title">
                Billing on : <span>{{ billingOn }}</span>
              </p>
              <p class="title">
                Trial end date : <span>{{ trialEndParsed }}</span>
              </p>
              <p class="title">
                Review import quota : <span>{{ reviewImportQuo }}</span>
              </p>
              <p class="title">
                Review import quota left:
                <span>{{ reviewImportQuotaLeft }}</span>
              </p>
              <p class="title">
                Credits left : <span>{{ creditsLeft }}</span>
              </p>
              <p class="title">
                Reviewed Opinew on appstore: <span>{{ reviewdOpinew }}</span>
              </p>
              <p class="title">
                API Key: <span>{{ shopAPIKey }}</span>
              </p>

              <v-divider class="my-4" />

              <p class="title">
                Photo Reviews: <span>{{ photoReviews }}</span>
              </p>
              <p class="title">
                Video Reviews: <span>{{ videoReviews }}</span>
              </p>
              <p class="title">
                Featured Reviews: <span>{{ featuredReviews }}</span>
              </p>
              <p class="title">
                Review Request Collection:
                <span v-if="reviewRequestCollection !== ''">
                  <span v-if="reviewRequestCollection">Active</span>
                  <span v-else>Not active</span>
                </span>
              </p>
              <p class="title text-capitalize">
                Opinew active plan: <span>{{ opinewPlan }}</span>
              </p>
              <p class="title text-capitalize">
                Trial days left: <span>{{ trialDaysLeft }}</span>
              </p>
              <p class="title text-capitalize">
                Active Integrations:
                <span v-for="(integration, index) in activeIntegrations" :key="index">
                  <span v-if="integration.active">{{ integration.name }} ,
                  </span>
                </span>
              </p>
              <p class="title text-capitalize" v-if="influencedRevenue">
                Influenced Reveune: <span>{{ influencedRevenue }}</span>
              </p>
              <p class="title text-capitalize mb-0" v-if="reviewRequests">
                Review Requests :
              </p>
              <p class="title text-capitalize mb-0" v-if="reviewRequests">
                Opened : {{ reviewRequests.opened }} /
                {{ reviewRequests.sent }} (sent)
              </p>
              <p class="title text-capitalize" v-if="reviewRequests">
                Completed : {{ reviewRequests.completed }} /
                {{ reviewRequests.sent }} (sent)
              </p>
              <p class="title text-capitalize">
                Influenced Orders : {{ influencedOrders }}
              </p>
              <p class="title text-capitalize">
                Total Orders : {{ totalOrders }}
              </p>
              <p class="title text-capitalize">
                Shopify Plan : {{ shopifyPlan }}
              </p>
              <p class="title text-capitalize">
                Subscription Date : {{ subscriptionDate }}
              </p>
              <p class="title text-capitalize">Plan Price : ${{ planPrice }}</p>
              <p class="title text-capitalize">
                Lifetime : ${{ lifetimeSpend }}
              </p>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex sm8 md8 style="    position: relative;    bottom: 25px;">
          <div>

            <v-layout row>

              <v-flex md6>
                <v-btn large :disabled="methodsEnabled == false" block @click="viewShop" :dark="methodsEnabled == true">
                  View Shop
                </v-btn>
              </v-flex>
              <v-flex md6>
                <v-btn large href="https://www.opinew.com/help-center/" target="_blank" block
                  style="background:cornflowerblue;">
                  Help Center
                </v-btn>
              </v-flex>

              <v-flex md6>
                <v-btn large dark block @click.native="snippetsDialog = true" style="background:gray;">
                  Opinew Snippets
                </v-btn>
              </v-flex>

              <v-flex md6>
                <v-btn large dark block @click.native="getReviewExamples">
                  Get Review Examples
                </v-btn>
              </v-flex>

            </v-layout>

            <v-divider></v-divider>
            <v-layout row>
              <v-flex xs12 sm12 md12>
                <h3>Edit Shop Account</h3>
              </v-flex>

              <template>
                <v-row justify="center">
                  <v-dialog v-model="trialDialog" persistent max-width="290">
                    <v-card>
                      <v-date-picker :picker-date.sync="pickerStart" v-model="newTrialDate"></v-date-picker>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.native.prevent="trialDialog = false" text>Close</v-btn>
                        <v-btn color="" text @click.native.prevent="changeTrial(2, newTrialDate)">Change</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>

              <v-flex md6>
                <DashboardButton @click.native.prevent="trialDialog = true" class="indigo"
                  :loadingval="this.btnStates[2].val" :disabled="methodsEnabled == false">Change trial date
                </DashboardButton>
              </v-flex>

              <template>
                <v-row justify="center">
                  <v-dialog v-model="importDialog" persistent max-width="600px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">Change Review Import Quota</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field v-model="importChange" label="Review imports to set" persistent-hint
                                required></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue" text @click="importDialog = false">Close</v-btn>
                        <v-btn color="blue" @click.native.prevent="
      changeReviewImportQuota(3, importChange)
      ">Change</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="importDialog = true" class="indigo"
                  :loadingval="this.btnStates[3].val" :disabled="methodsEnabled == false">Change review import quota
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="requestDialog = true" class="indigo"
                  :loadingval="this.btnStates[4].val" :disabled="methodsEnabled == false">Change Credits Left
                </DashboardButton>

                <template>
                  <v-row justify="center">
                    <v-dialog v-model="requestDialog" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Change Credits Left</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="requestChange" label="Credits to set" persistent-hint
                                  required></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="requestDialog = false">Close</v-btn>
                          <v-btn color="blue" @click.native.prevent="
      changeCreditsLeft(4, requestChange)
      ">Change</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </v-flex>

              <template>
                <v-row justify="center">
                  <v-dialog v-model="moveReviewsDialog" persistent max-width="600px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">Move Reviews from Product to Another</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-autocomplete :items="productsDetailFrom" :search-input.sync="searchProductFrom"
                                v-model="productFrom" label="Choose a Source Product" item-text="name" item-value="id">
                                <template slot="item" slot-scope="data">
                                  {{ data.item.name }} -
                                  <div>
                                    Total Reviews:
                                    {{ data.item.reviewsCount }}
                                  </div>
                                  - Deleted Reviews :
                                  {{ data.item.reviewsDeletedCount }} - Handle :
                                  {{ data.item.handle }}
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-autocomplete :items="productsDetailTo" :search-input.sync="searchProductTo"
                                v-model="productTo" label="Choose a Destination Product" item-text="name"
                                item-value="id">
                                <template slot="item" slot-scope="data">
                                  {{ data.item.name }} -
                                  <div>
                                    Total Reviews:
                                    {{ data.item.reviewsCount }}
                                  </div>
                                  - Deleted Reviews :
                                  {{ data.item.reviewsDeletedCount }} - Handle :
                                  {{ data.item.handle }}
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue" text @click="moveReviewsDialog = false">Close</v-btn>
                        <v-btn color="blue" @click.native.prevent="
      moveReviewsFrom(18, productFrom, productTo)
      ">Change</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="moveReviewsDialog = true" :loadingval="this.btnStates[18].val"
                  class="indigo" :disabled="methodsEnabled == false">Move Reviews From Product
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="refreshShopPermissions(26)" :loadingval="this.btnStates[26].val"
                  class="indigo" :disabled="methodsEnabled == false">Update
                  Shop's Permissions
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="permissionsDialog = true" class="indigo"
                  :loadingval="this.btnStates[28].val" :disabled="methodsEnabled == false">Add/Remove Permission
                </DashboardButton>

                <template>
                  <v-row justify="center">
                    <v-dialog v-model="permissionsDialog" max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Add / Remove Permission</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="6">
                                <v-autocomplete v-model="selectedPermission" item-value="name" item-text="name" filled
                                  :items="allPermissions"></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="12" md="6">
                                <v-autocomplete v-model="selectedPermissionValue" item-value="value" item-text="label"
                                  filled :items="permissionsOptions"></v-autocomplete>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12">
                                <h2 class="mb-6 black--text">
                                  Shop's Permissions
                                </h2>

                                <div v-for="permission in selectedShopsPermissions" :key="permission.name">
                                  {{ permission }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="permissionsDialog = false">Close</v-btn>
                          <v-btn color="blue" @click.native.prevent="updatePermission(28)">Change</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="addReferralDialog = true" :loadingval="this.btnStates[19].val"
                  class="indigo" :disabled="methodsEnabled == false">Add referral to shop
                </DashboardButton>

                <template>
                  <v-row justify="center">
                    <v-dialog v-model="addReferralDialog" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Add referral to shop</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-autocomplete :items="referralOffers" v-model="referralSelection"
                                  label="Choose a Referral Code" item-text="referralCode" item-value="referralCode">
                                  <template slot="item" slot-scope="data">
                                    {{ data.item.referralCode }} - %{{
      data.item.discount
    }}
                                    off discount
                                  </template>
                                </v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="addReferralDialog = false">Close</v-btn>
                          <v-btn color="blue" @click.native.prevent="
      assignDiscountToShop(18, referralSelection)
      ">Change</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="blockSpamShopDialog = true" :loadingval="this.btnStates[39].val"
                  class="red" :disabled="methodsEnabled == false">Emergency block shop</DashboardButton>

                <template>
                  <v-row justify="center">
                    <v-dialog v-model="blockSpamShopDialog" persistent max-width="500px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Emergency block shop</span>
                        </v-card-title>
                        <v-card-text>
                          Are you sure you want to block this shop? This will deactivate the shop, remove permissions,
                          delete email templates, and mark all products as deleted.
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="blockSpamShopDialog = false">No</v-btn>
                          <v-btn color="error" dark @click.native.prevent="blockSpamShop(39)">Yes</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </v-flex>


            </v-layout>
            <br>
            <v-divider></v-divider>





            <v-layout row>


              <v-flex sm12 md12>
                <h3>Synchronisation</h3>
              </v-flex>
              <v-flex md6>
                <DashboardButton @click.native.prevent="synchroniseAllOrders(0)" class="indigo"
                  :loadingval="this.btnStates[0].val" :disabled="methodsEnabled == false">Synchronise all orders
                </DashboardButton>
              </v-flex>

              <v-flex md6>
                <DashboardButton @click.native.prevent="synchroniseAllProducts(1)" class="indigo"
                  :loadingval="this.btnStates[1].val" :disabled="methodsEnabled == false">Synchronise all products
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="fullProductStatsResync(15)" class="indigo"
                  :loadingval="this.btnStates[15].val" :disabled="methodsEnabled == false">Full Products Stats Resync
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="fullShopStatsResync(16)" class="indigo"
                  :loadingval="this.btnStates[16].val" :disabled="methodsEnabled == false">Full Shop Stats Resync
                </DashboardButton>
              </v-flex>

              <v-flex md6>
                <DashboardButton @click.native.prevent="resyncAllMeta(8)" class="indigo"
                  :loadingval="this.btnStates[8].val" :disabled="methodsEnabled == false">Resync all metafields
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="refreshScriptTag(10)" class="indigo"
                  :loadingval="this.btnStates[10].val" :disabled="methodsEnabled == false">Refresh Script Tag
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="updateShopMetafields(17)" class="indigo"
                  :loadingval="this.btnStates[17].val" :disabled="methodsEnabled == false">Update shop metafields
                </DashboardButton>
              </v-flex>

              <v-flex md6>
                <DashboardButton @click.native.prevent="refreshGoogleFeed(11)" class="indigo"
                  :loadingval="this.btnStates[11].val" :disabled="methodsEnabled == false">Refresh Google Feed
                </DashboardButton>
              </v-flex>


              <v-flex md6>
                <DashboardButton @click.native.prevent="unstuckImportEntries(34)" class="indigo"
                  :loadingval="this.btnStates[34].val" :disabled="methodsEnabled == false">Unstuck Import Entries
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="resyncCrossShopLinkedProducts(23)"
                  :loadingval="this.btnStates[23].val" class="indigo" :disabled="methodsEnabled == false">Resync Cross
                  Shop Linked Products
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="removeShopsDuplicatedReviews(29)"
                  :loadingval="this.btnStates[29].val" class="indigo" :disabled="methodsEnabled == false">Remove Shop's
                  Duplicated Reviews
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="fixRatings(38)"
                  :loadingval="this.btnStates[38].val" class="indigo" :disabled="methodsEnabled == false">Fix shop's
                  product ratings
                </DashboardButton>
              </v-flex>


            </v-layout>


            <v-divider></v-divider>

            <v-layout row>
              <v-flex sm 12 md12>
                <h3>Shopify Liquid &amp; Installation</h3>
              </v-flex>

              <v-flex xs12 v-if="currentStore">
                <v-autocomplete :items="chosenStoreThemes" v-model="chosenTheme" label="Choose Store Theme "
                  item-text="text" item-value="id"></v-autocomplete>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="installShopCode(5)" class="indigo"
                  :loadingval="this.btnStates[5].val" :disabled="methodsEnabled == false">Install shop code
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="uninstallShopCode(7)" class="indigo"
                  :loadingval="this.btnStates[7].val" :disabled="methodsEnabled == false">Uninstall shop code
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="installLiquidSnippets(6)" class="indigo"
                  :loadingval="this.btnStates[6].val" :disabled="methodsEnabled == false">Install Liquid Snippets
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="resetInstallationDialog = true" class="indigo"
                  :loadingval="this.btnStates[21].val" :disabled="methodsEnabled == false">Reset Widgets Installation
                </DashboardButton>

                <template>
                  <v-row justify="center">
                    <v-dialog v-model="resetInstallationDialog" persistent max-width="600px">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Reset Installation Process</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-autocomplete :items="themeStatus" v-model="themeSelection" label="Choose a Theme Id"
                                  item-text="id" item-value="id">
                                </v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue" text @click="resetInstallationDialog = false">Close</v-btn>
                          <v-btn color="blue" @click.native.prevent="
      resetInstallation(21, themeSelection)
      ">Change</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="showCodeViaHider(12)" class="indigo"
                  :loadingval="this.btnStates[12].val" :disabled="methodsEnabled == false">Show code via hider
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="hideCodeViaHider(13)" class="indigo"
                  :loadingval="this.btnStates[13].val" :disabled="methodsEnabled == false">Hide code via hider
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="removeOpinewBranding(30)" :loadingval="this.btnStates[30].val"
                  class="indigo" :disabled="methodsEnabled == false">Remove Opinew Branding
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="removeScriptTag(31)" :loadingval="this.btnStates[31].val"
                  class="indigo" :disabled="methodsEnabled == false">Remove Script Tag
                </DashboardButton>
              </v-flex>


            </v-layout>
            <v-divider></v-divider>

            <v-layout row>
              <v-flex sm 12 md12>
                <h3>Customer Success</h3>
              </v-flex>




              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="createDiscountDialog = true" class="indigo"
                  :loadingval="this.btnStates[32].val">Create Custom Discount
                </DashboardButton>
              </v-flex>



              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="allowPlanChange(9)" class="indigo"
                  :loadingval="this.btnStates[9].val" :disabled="methodsEnabled == false">Allow Change Plan
                </DashboardButton>
              </v-flex>


              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="createThreeMonthDiscountDialog = true"
                  :disabled="methodsEnabled == false" class="indigo" :loadingval="this.btnStates[33].val">Create 3 month
                  Discount
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="resetOnboarding(35)" :loadingval="this.btnStates[35].val"
                  class="indigo" :disabled="methodsEnabled == false">Reset onboarding progress
                </DashboardButton>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="enableEnterpriseUpgradeButton(36)"
                  :loadingval="this.btnStates[36].val" class="indigo" :disabled="methodsEnabled == false">Enable
                  enterprise upgrade button
                </DashboardButton>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="enableAdvancedTemplateButton(37)"
                  :loadingval="this.btnStates[37].val" class="indigo" :disabled="methodsEnabled == false">Enable
                  advanced email template and test email button
                </DashboardButton>
              </v-flex>

              <v-dialog v-model="createDiscountDialog" transition="dialog-bottom-transition" max-width="600">
                <v-card>
                  <v-toolbar color="primary" dark>Opening from the bottom</v-toolbar>
                  <v-card-text>
                    <v-form ref="discountform" v-model="discountValid">
                      <v-autocomplete style="margin-top:30px;" :rules="[validation.required]" multiple clearable
                        @change="chosenOpinewDiscountPlanHandler" :items="plans" v-model="chosenOpinewPlanDiscount"
                        label="Choose a Plan" item-text="name" item-value="id" return-object></v-autocomplete>
                      <v-text-field :rules="[validation.maxHundred]" type="number" v-model="discountAmount"
                        label="Discount amount" required></v-text-field>
                      <v-text-field :rules="[validation.trialDays]" type="number" v-model="trialDaysAmount"
                        label="Trial days amount" required></v-text-field>
                      <v-text-field :rules="[validation.discountPeriodsRule]" type="number" v-model="discounMonthPeriod"
                        label="Discount month period (0 means unlimited)" required></v-text-field>
                      <p>Expiry date:</p>
                      <v-date-picker :rules="[validation.required]" v-model="newDiscountExpiryDate"
                        :min="new Date().toLocaleDateString('fr-CA')"></v-date-picker>
                      <v-text-field disabled :rules="[validation.required]" v-model="newDiscountExpiryDate"
                        required></v-text-field>
                    </v-form>

                    <div v-if="lastCreatedDiscount">
                      <h2>Last created discount</h2>
                      <p class="mt-4">Code : {{ lastCreatedDiscount }}</p>
                      <p>
                        Plans:
                        <span v-for="plan in lastDiscountChosenPlans" :key="plan.id">
                          {{ plan.name }},
                        </span>
                      </p>
                      <p>Discount : {{ lastDiscountAmount }}%</p>
                      <p>Free trial days : {{ lastDiscountDaysTrial }}</p>
                      <p>
                        Discount month period: {{ lastDiscountMonthPeriod }}
                      </p>
                      <p>Expiry : {{ lastDiscountExpiryDate }}</p>
                    </div>
                    <p v-if="lastCreatedDiscountDate">
                      Last created discount code date :
                      {{ lastCreatedDiscountDate }}
                    </p>

                    <div v-if="lastFiveCoupons">
                      <h2>Last five created coupons</h2>
                      <div class="mt-4" v-for="coupon in lastFiveCoupons" :key="coupon.id">
                        <p>{{ coupon.coupon }}</p>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn text @click="createDiscountDialog = false">Close</v-btn>
                    <v-btn :disabled="!discountValid" text @click="createCustomDiscount(32)">Create Discount</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="createThreeMonthDiscountDialog" transition="dialog-bottom-transition" max-width="600">
                <v-card>
                  <v-toolbar color="primary" dark>Opening from the bottom</v-toolbar>
                  <v-card-text>
                    <v-form ref="threeMonthDiscountForm" v-model="threeMonthDiscountValid">
                      <v-autocomplete style="margin-top:30px;" :rules="[validation.required]" multiple clearable
                        @change="chosenOpinewThreeMonthDiscountPlanHandler" :items="plans"
                        v-model="chosenOpinewPlanThreeMonthDiscount" label="Choose a Plan" item-text="name"
                        item-value="id"></v-autocomplete>
                      <v-autocomplete v-model="discountAmountThreeMonths" item-value="value" item-text="label"
                        label="Choose discount percentage" filled :items="discountOptions"></v-autocomplete>
                      <v-text-field :rules="[validation.trialDays]" type="number" v-model="trialDaysAmountThreeMonths"
                        label="Trial days amount" required></v-text-field>
                    </v-form>

                    <p v-if="lastCreatedDiscount">
                      Last created discount code : {{ lastCreatedDiscount }}
                    </p>
                    <p v-if="lastCreatedDiscountDate">
                      Last created discount code date :
                      {{ lastCreatedDiscountDate }}
                    </p>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn text @click="createThreeMonthDiscountDialog = false">Close</v-btn>
                    <v-btn :disabled="!threeMonthDiscountValid" text @click="createThreeMonthDiscount(33)">Create
                      Discount</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>

            <v-divider class="my-4" />

            <v-layout row>
              <v-flex sm12 md12>
                <h3>CSV Review Migration</h3>
              </v-flex>

              <v-flex md12>
                <p>
                  Upload custom CSV files to migrate reviews to the selected shop
                  <a href="https://cdn.opinew.com/global/custom-csv-template-v4.csv" target="_blank">
                    Download template
                  </a>
                </p>
              </v-flex>

              <v-flex md12>
                <v-file-input
                  accept=".csv"
                  placeholder="Add CSV files"
                  v-model="migrationCsvFiles"
                  multiple
                  outlined
                  dense
                  small
                  :disabled="!methodsEnabled || migrationCsvUploading"
                />
                <DashboardButton
                  @click.native.prevent="uploadMigrationCsvFiles"
                  class="indigo"
                  :loadingval="migrationCsvUploading"
                  :disabled="methodsEnabled == false || !migrationCsvFiles || migrationCsvFiles.length === 0"
                >Start CSV migration</DashboardButton>
              </v-flex>
            </v-layout>

            <v-divider class="my-4" />

            <v-layout row>
              <v-flex sm 12 md12>
                <h3>Walmart Functions</h3>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="rewriteWalmartReviews(24)" class="indigo"
                  :loadingval="this.btnStates[24].val" :disabled="methodsEnabled == false">Rewrite Reviews
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="exportWalmartFeed(25)" class="indigo"
                  :loadingval="this.btnStates[25].val" :disabled="methodsEnabled == false">Export Walmart Feed
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <DashboardButton @click.native.prevent="exportWalmartSampleFeed(27)"
                  :loadingval="this.btnStates[27].val" class="indigo" :disabled="methodsEnabled == false">Export Walmart
                  Sample Feed
                </DashboardButton>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <v-select v-model="uniqueness" :items="uniquenessOptions" filled label="Uniqueness" dense></v-select>
              </v-flex>

              <v-flex md12>
                <v-file-input accept=".csv" placeholder="Add CSV" v-model="file" outlined dense small />
                <v-btn :disabled="!file" @click="processWalmartSkuMappingFile">Process walmart file</v-btn>
              </v-flex>
            </v-layout>


          </div>
        </v-flex>
      </v-layout>

      <v-dialog v-model="snippetsDialog" max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Opinew Snippets
          </v-card-title>

          <v-card-text>
            <pre class="wp-block-code">
          &lt;div id='opinew-stars-plugin-product'&gt;{% render 'opinew_review_stars_product' product:product
          %}&lt;/div&gt;</pre>

            <pre class="mt-5 wp-block-code">
          &lt;div class='opinew-stars-plugin-product-list'&gt;{% render 'opinew_review_stars_lists' product:product
          %}&lt;/div&gt;</pre>

            <pre class="mt-5 wp-block-code" v-pre>
          &lt;div style="clear:both;"&gt;&lt;/div&gt;&lt;div id="opinew-reviews-product-page-code" class=""&gt;
          &lt;span id="opinew-plugin"
          data-server-address="https://www.opinew.com"
          data-platform-product-id="{{ product.id }}"&gt;
          data-opw-prodreviews="{{
          product.metafields.opinew_metafields['product_plugin']
          }}"
          data-opinew-shop-id="{{ shop.id }}" data-shop-url="{{ shop.domain }}"
          &lt;span id="opinew_product_plugin_app"&gt;&lt;/span&gt;&lt;/span&gt;&lt;/div&gt; </pre>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click.native="snippetsDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="examplesDialog" max-width="1200">
        <v-card min-height="500">
          <v-card-title class="headline">
            Get Review Examples
          </v-card-title>

          <div v-if="reviewLoading" class="d-flex justify-center my-8">
            <v-progress-circular class="mt-16" indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else>
            <v-card-text class="my-8">
              <v-textarea rows="10" solo :value="parsedReview" read-only="true" ref="reviewText" />
            </v-card-text>

            <v-btn absolute text top right color="primary_lighten3" @click.native="copyWidgetCode">
              <v-icon class="text-subtitle-2">mdi-content-copy </v-icon>
            </v-btn>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="indigo" dark @click.native="getReviewExamples">
                Generate new example
              </v-btn>
              <v-btn color="warning" @click.native="examplesDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackState" top color="success">
        {{ snackText }}
        <v-btn color="white" text @click="snackState = false"> Close </v-btn>
      </v-snackbar>

      <!-- Products -->
      <v-layout row class="mt-16" v-if="contentTabs === 0">
        <v-flex md12>
          <DashboardTable table-name="Products" :expanded-rows="true"
            @publishReviewsClicked="publishAllReviewsOneProduct" @undeleteReviewsClicked="undeleteAllReviewsOneProduct"
            @metaClicked="updateShopProductMetafields" @syncClicked="synchroniseShopProductReviews"
            @expClicked="updateCurrentProduct" @importClicked="synchroniseShopProductImportEntryReviews"
            @removeDuplicatedReviewsClicked="removeDuplicatedShopsReviews" :headers="headers" :settings="settings"
            :items="products" :import-items="importItems" :methods-enabled="methodsEnabled"
            :shop-domain="computedShopDomain"></DashboardTable>
        </v-flex>
        <v-flex md6> </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import DashboardButton from './DashboardButton';
import DashboardTable from './DashboardTable';

import expMeth from '@/assets/methods.js';

export default {
  name: 'Dashboard',
  components: {
    DashboardButton,
    DashboardTable,
  },
  mounted: function () {
    this.fetchLastFiveDiscounts();
    this.plansList();
    this.shopList('');
    this.generatePaulTable();
    this.getFilters();
    this.loadWorkingGroups();
  },
  computed: {
    activeFilter() {
      const name = this.paulSearch
      const plan_opw = this.chosenOpinewPlan;
      const plan_spf = this.chosenShopifyPlan;
      const mrr = [this.chosenMrrOption, this.mrrValue].join(' ')
      const integ = this.filteredIntegration.join(' ')
      return { 'Shop': name, 'Opinew plan': plan_opw, 'Shopify plan': plan_spf, 'MRR': mrr, 'Integrations': integ, 'Price greater than': this.chosenPrice }
    },

    filteredPlan() {
      const query = this.searchPlan
      if (this.searchPlan == '') {
        return nulll;
      }
      return this.searchPlan
    },
    parsedReview() {
      return `Also, I hope it’s not too much to ask, but could you leave me a review if you’re happy with our support and the app features? It would do me a big favour!
Thinking of what to put can be hard so I can pre-write it so that you have an example:
${this.parsedExamples}

you can use this link to leave a review directly 😁
https://apps.shopify.com/photo-reviews/reviews#modal-show=WriteReviewModal
  `;
    },
    discountPlans() {
      return this.chosenOpinewPlanDiscount.map((item) => item.id);
    },
    defaultMainTheme() {
      if (this.chosenStoreThemes) {
        return this.chosenStoreThemes.filter((theme) => theme.main);
      } else {
        return '';
      }
    },
    searchTerm() {
      return this.search == null ? '' : this.search;
    },
    trialEndParsed() {
      return this.trialEnd ? this.trialEnd.toDateString() : '';
    },
    trialDaysLeft() {
      if (this.trialEnd) {
        const today = new Date();

        const diffTime = today.getTime() - this.trialEnd.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

        return diffDays > 0 ? 0 : diffDays * -1;
      } else {
        return '';
      }
    },
    lifetimeSpend() {
      if (this.trialCreation) {
        const today = new Date();

        const diffTime = today.getTime() - this.trialCreation.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

        return (Math.round(diffDays / 30) * this.planPrice).toFixed(2);
      } else {
        return '';
      }
    },
    computedShopDomain() {
      if (this.shopDomain == '' || this.shopDomain == null) {
        return '#';
      } else {
        if (
          !this.shopDomain.includes('https://') &&
          !this.shopDomain.includes('http://')
        ) {
          return 'https://' + this.shopDomain;
        }
        return this.shopDomain;
      }
    },
    items() {
      return this.entries.map((entry) => {
        const Description =
          entry.Description.length > this.descriptionLimit
            ? entry.Description.slice(0, this.descriptionLimit) + '...'
            : entry.Description;

        return Object.assign({}, entry, { Description });
      });
    },
  },

  methods: {
    ...expMeth,
    placeholderMethod() {
      console.log('Placeholder');
    },
    paginationCustomerHandler(e) {
      this.paginationStart = e.pageStart;
    },
    pageCountHandler(e) {
      this.shopFetchCount = e;
    },
    viewShop() {
      window.open(
        this.computedShopDomain,
        '_blank' // <- This is what makes it open in a new window.
      );
    },
    chosenOpinewPlanHandler(e) {
      this.chosenOpinewPlan = e === null ? '' : e;
    },
    chosenOpinewDiscountPlanHandler(e) {
      this.chosenOpinewPlanDiscount = e === null ? '' : e;
    },
    chosenOpinewThreeMonthDiscountPlanHandler(e) {
      this.chosenOpinewPlanThreeMonthDiscount = e === null ? '' : e;
    },
    chosenMrrOptionHandler(e) {
      this.mrr_option = e === null ? '' : e;
    },
    chosenPriceOptionHandler(e) {
      this.price_option = e === null ? '' : e;
    },
    chosenIntegrationsHandler(e) {
      this.integrations = e === null ? '' : e;
    },
    chosenFilterHandler(e) {
      this.filter = e === null ? '' : e;
    },
    chosenWorkingGroupHandler(e) {
      this.working = e === null ? '' : e;
    },
    sortByHandler(e) {
      if (e == undefined) {
        this.sortBy = 'shop_created_at';
      }
    },
    descHandler(e) {
      if (e === undefined) {
        this.descendingValue = true;
      }
      this.fetchEntriesDebounced();
    },
    chosenShopifyPlanHandler(e) {
      this.chosenShopifyPlan = e === null ? '' : e;
    },
    dateFormated(date) {
      if (date) {
        const dateParsed = new Date(date);

        return `${dateParsed
          .toLocaleString('en-GB', { timeZone: 'UTC' })
          .substring(0, 30)}`;
      } else {
        return '';
      }
    },
    trialDaysLeftHandler(date) {
      if (date) {
        const dateParsed = new Date(date);
        const today = new Date();
        const diffTime = today.getTime() - dateParsed.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));

        return diffDays > 0 ? 0 : diffDays;
      } else {
        return '';
      }
    },
    lifetimeSpendHandler(dateCreation, price) {
      if (dateCreation) {
        const dateParsed = new Date(dateCreation);
        const today = new Date();

        const diffTimconste = today.getTime() - dateParsed.getTime();
        const diffDays = Math.ceil(diffTimconste / (1000 * 3600 * 24)) * price;

        return diffDays;
      } else {
        return '';
      }
    },
  },
  watch: {
    paginationStart() {
      this.shopsLoading = true;

      if (this.shopsLoading) {
        this.fetchEntriesDebounced();
      }
    },
    shopFetchCount() {
      this.shopsLoading = true;

      if (this.shopsLoading) {
        this.fetchEntriesDebounced();
      }
    },
    search(val) {
      if (val == '') {
        this.fetchEntriesDebounced();
      }

      if (!val) {
        return;
      }

      this.fetchEntriesDebounced();
    },
    searchProductFrom(val) {
      if (val == '') {
        this.fetchProductsFromDebounced();
      }

      if (!val) {
        return;
      }

      this.fetchProductsFromDebounced();
    },
    searchProductTo(val) {
      if (val == '') {
        this.fetchProductsToDebounced();
      }

      if (!val) {
        return;
      }

      this.fetchProductsToDebounced();
    },
  },
  data() {
    return {
      searchPlan: '',
      selectedPlan: null,
      planIsVisible: false,
      lastDiscountMonthPeriod: '',
      discounMonthPeriod: '',
      lastFiveCoupons: [],
      lastDiscountChosenPlans: [],
      lastDiscountAmount: '',
      lastDiscountDaysTrial: '',
      lastDiscountExpiryDate: '',
      discountValid: false,
      threeMonthDiscountValid: false,
      validation: {
        maxHundred: (v) => {
          return (!!v && v > 0 && v < 101) || 'Invalid discount amount';
        },
        trialDays: (v) => {
          return (!!v && v > -1) || 'Invalid amount of days';
        },
        discountPeriodsRule: (v) => {
          return (!!v && v > -1) || 'Invalid amount of periods';
        },
        required: (v) => {
          return v != '' || 'This value is required';
        },
      },
      chosenOpinewPlanDiscount: [],
      chosenOpinewPlanThreeMonthDiscount: '',
      trialDaysAmount: '',
      discountPeriods: '',
      trialDaysAmountThreeMonths: '',
      discountAmount: '',
      discountAmountThreeMonths: '',
      newDiscountExpiryDate: new Date().toLocaleDateString('fr-CA'),
      createDiscountDialog: false,
      createThreeMonthDiscountDialog: false,
      discountOptions: [
        { value: 10, label: '10%' },
        { value: 20, label: '20%' },
        { value: 30, label: '30%' },
      ],
      lastCreatedDiscount: '',
      lastCreatedDiscountDate: '',
      file: null,
      migrationCsvFiles: [],
      migrationCsvUploading: false,
      parsedExamples: '',
      reviewLoading: false,
      examplesDialog: false,
      selectedPermission: '',
      selectedPermissionValue: '',
      permissionsOptions: [
        { value: true, label: 'True' },
        { value: false, label: 'False' },
      ],
      permissionsDialog: '',
      allPermissions: '',

      selectedShopsPermissions: '',
      uniquenessOptions: [1, 2, 3],
      uniqueness: 1,
      chosenTheme: null,
      chosenStoreThemes: [],
      shopsLoading: false,
      rowsPerPageItems: [5, 10, 20, 30, 40],
      shopFetchCount: 20,
      totalShopsCount: 0,
      paulTotalShopsCount: 0,
      paginationStart: 0,
      sortBy: 'name',
      descendingValue: true,
      shopifyPlans: [
        {
          id: 1,
          name: 'shopify_plus',
          label: 'Shopify Plus',
        },
        {
          id: 2,
          name: 'professional',
          label: 'Professional',
        },
        {
          id: 3,
          name: 'unlimited',
          label: 'Unlimited',
        },
        {
          id: 4,
          name: 'staff_business',
          label: 'Staff Business',
        },
        {
          id: 5,
          name: 'staff',
          label: 'Staff',
        },
        {
          id: 6,
          name: 'enterprise',
          label: 'Enterprise',
        },
        {
          id: 7,
          name: 'basic',
          label: 'Basic',
        },
        {
          id: 8,
          name: 'frozen',
          label: 'Frozen',
        },
        {
          id: 9,
          name: 'dormant',
          label: 'Dormant',
        },
        {
          id: 10,
          name: 'partner_test',
          label: 'Partner Test',
        },
        {
          id: 11,
          name: 'affiliate',
          label: 'Affiliate',
        },
      ].sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      }),
      reviewImportQuotaLeft: '',
      shopCreatedAt: '',
      chosenOpinewPlan: '',
      chosenShopifyPlan: '',
      chosenMrrOption: '',
      chosenPriceOption: '',
      mrrValue: 0,
      plans: '',
      planPrice: '',
      subscriptionDate: '',
      shopifyPlan: '',
      influencedOrders: '',
      totalOrders: '',
      reviewRequests: '',
      influencedRevenue: '',
      activeIntegrations: '',
      photoReviews: '',
      videoReviews: '',
      featuredReviews: '',
      contentTabs: 0,
      opinewPlan: '',
      reviewRequestCollection: '',
      referralSelection: null,
      productFrom: null,
      productTo: null,
      moveReviewsDialog: false,
      addReferralDialog: false,
      referralOffers: [],
      themeStatus: null,
      snippetsDialog: false,
      themeSelection: null,
      resetInstallationDialog: false,
      blockSpamShopDialog: false,
      shopDetails: false,
      newWorkingGroup: false,
      shopAPIKey: '',
      shopDomain: '',
      pickerStart: '',
      trialDialog: false,
      importDialog: false,
      importChange: '',
      requestDialog: false,
      planDialog: false,
      requestChange: '',
      newTrialDate: new Date().toISOString().substr(0, 10),
      btnStates: [
        { id: 1, val: false },
        { id: 2, val: false },
        { id: 3, val: false },
        { id: 4, val: false },
        { id: 5, val: false },
        { id: 6, val: false },
        { id: 7, val: false },
        { id: 8, val: false },
        { id: 9, val: false },
        { id: 10, val: false },
        { id: 11, val: false },
        { id: 12, val: false },
        { id: 13, val: false },
        { id: 14, val: false },
        { id: 15, val: false },
        { id: 16, val: false },
        { id: 17, val: false },
        { id: 18, val: false },
        { id: 19, val: false },
        { id: 20, val: false },
        { id: 21, val: false },
        { id: 22, val: false },
        { id: 23, val: false },
        { id: 24, val: false },
        { id: 25, val: false },
        { id: 26, val: false },
        { id: 27, val: false },
        { id: 28, val: false },
        { id: 29, val: false },
        { id: 30, val: false },
        { id: 31, val: false },
        { id: 32, val: false },
        { id: 33, val: false },
        { id: 34, val: false },
        { id: 35, val: false },
        { id: 36, val: false },
        { id: 37, val: false },
        { id: 38, val: false },
        { id: 39, val: false },
        { id: 40, val: false },
      ],
      descriptionLimit: 60,
      shops: [],

      paulShops: [],
      paulSelected: '',
      isLoading: false,
      shop: '',
      paulSearch: '',
      search: '',
      searchType: 'default',
      searchProductFrom: '',
      searchProductTo: '',
      snackState: false,
      snackText: '',
      methodsEnabled: false,
      currentStore: '',
      currentProduct: '',
      idkyet: false,
      storeName: '',
      billingOn: '',
      trialEnd: null,
      trialCreation: '',
      creditsLeft: '',
      reviewImportQuo: '',
      reviewdOpinew: '',
      settings: {
        expanded: [],
        singleExpand: true,
        search: '',
      },
      settingsCustomer: {
        expanded: [],
        singleExpand: false,
        search: '',
      },
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        { text: 'Id', value: 'id' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'end',
        },
        { text: '', value: 'data-table-expand' },
      ],
      headersCustomer: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        { text: 'Opinew Plan', value: 'activePlan' },
        { text: 'Plan Price', value: 'planPrice' },
        { text: 'Shopify Plan', value: 'shopifyPlan' },
        { text: 'Lifetime spent', value: 'lifetimeSpend' },
        { text: 'Influended Revenue', value: 'mrr' },
        { text: 'Reviews', value: 'total_reviews' },
        { text: 'With Opinew since', value: 'shopCreatedAt' },
        { text: 'Details', value: 'details' },
        { text: '', value: 'add' },
        { text: '', value: 'remove' },

      ],
      products: [],
      productsDetailFrom: [],
      productsDetailTo: [],
      importItems: [],
      chosenPrice: 0,
      filterNameDialog: false,
      mrr_options: [
        {
          id: 0,
          name: 'equal',
          label: 'Equal',
        },
        {
          id: 1,
          name: 'smaller',
          label: 'Smaller',
        },
        {
          id: 4,
          name: 'bigger',
          label: 'Bigger',
        },

      ],

      price_options: [
        {
          id: 0,
          name: 'equal',
          label: 'Equal',
        },
        {
          id: 1,
          name: 'smaller',
          label: 'Smaller',
        },
        {
          id: 4,
          name: 'bigger',
          label: 'Bigger',
        },

      ],

      opwPlans: [
        {
          id: 0,
          name: 'advanced',
          label: 'Advanced',
        },
        {
          id: 1,
          name: 'advanced_2023',
          label: 'Advanced (2023)',
        },
        {
          id: 2,
          name: 'annual_advanced',
          label: 'Advanced (Annual)',
        },
        {
          id: 3,
          name: 'annual_advanced_2023',
          label: 'Advanced (Annual 2023)',
        },
        {
          id: 4,
          name: 'annual_corporation',
          label: 'Corporation (Annual)',
        },
        {
          id: 5,
          name: 'annual_corporation_sliders',
          label: 'Corporation Sliders (Annual)',
        },
        {
          id: 6,
          name: 'annual_enterprise',
          label: 'Enterprise (Annual)',
        },
        {
          id: 7,
          name: 'annual_enterprise_2023',
          label: 'annual_enterprise_2023',
        },
        {
          id: 8,
          name: 'annual_enterprise_sliders',
          label: 'annual_enterprise_sliders',
        },
        {
          id: 9,
          name: 'annual_growth',
          label: 'annual_growth',
        },
        {
          id: 10,
          name: 'annual_growth_2023',
          label: 'annual_growth_2023',
        },
        {
          id: 11,
          name: 'annual_high_251018',
          label: 'Annual_High_251018',
        },
        {
          id: 12,
          name: 'annual_low_100119',
          label: 'Annual_Low_100119',
        },
        {
          id: 13,
          name: 'annual_medium_251018',
          label: 'Annual_Medium_251018',
        },
        {
          id: 14,
          name: 'annual_medium_290618',
          label: 'Annual_Medium_290618',
        },
        {
          id: 15,
          name: 'annual_shop',
          label: 'annual_shop',
        },
        {
          id: 16,
          name: 'annual_shop_sliders',
          label: 'annual_shop_sliders',
        },
        {
          id: 17,
          name: 'annual_side_gig',
          label: 'annual_side_gig',
        },
        {
          id: 18,
          name: 'annual_side_gig_sliders',
          label: 'annual_side_gig_sliders',
        },
        {
          id: 19,
          name: 'annual_starter',
          label: 'annual_starter',
        },
        {
          id: 20,
          name: 'annual_warehouse',
          label: 'annual_warehouse',
        },
        {
          id: 21,
          name: 'annual_warehouse_sliders',
          label: 'annual_warehouse_sliders',
        },
        {
          id: 22,
          name: 'anylilcustom',
          label: 'AnyLilCustom',
        },
        {
          id: 23,
          name: 'arctica',
          label: 'arctica',
        },
        {
          id: 24,
          name: 'bargains',
          label: 'Bargains',
        },
        {
          id: 25,
          name: 'biokoma',
          label: 'BIOKOMA',
        },
        {
          id: 26,
          name: 'corporation',
          label: 'corporation',
        },
        {
          id: 27,
          name: 'corporation_sliders',
          label: 'corporation_sliders',
        },
        {
          id: 28,
          name: 'developer',
          label: 'Developer',
        },
        {
          id: 29,
          name: 'dormant',
          label: 'Dormant',
        },
        {
          id: 30,
          name: 'enterprise',
          label: 'enterprise',
        },
        {
          id: 31,
          name: 'enterprise_2023',
          label: 'enterprise_2023',
        },
        {
          id: 32,
          name: 'enterprise_sliders',
          label: 'enterprise_sliders',
        },
        {
          id: 33,
          name: 'esn',
          label: 'ESN',
        },
        {
          id: 34,
          name: 'fragrance',
          label: 'Fragrance',
        },
        {
          id: 35,
          name: 'free',
          label: 'free',
        },
        {
          id: 36,
          name: 'free_071017',
          label: 'Free_071017',
        },
        {
          id: 37,
          name: 'free_choose_plan',
          label: 'Free_Choose_Plan',
        },
        {
          id: 38,
          name: 'free_choose_plan2',
          label: 'Free_Choose_Plan2',
        },
        {
          id: 39,
          name: 'free_double_11117',
          label: 'Free_Double_11117',
        },
        {
          id: 40,
          name: 'free_starting_shop_plan',
          label: 'Free_Starting_Shop_Plan',
        },
        {
          id: 41,
          name: 'growth',
          label: 'growth',
        },
        {
          id: 42,
          name: 'growth_2023',
          label: 'growth_2023',
        },
        {
          id: 43,
          name: 'heroes',
          label: 'heroes',
        },
        {
          id: 44,
          name: 'high_251018',
          label: 'High_251018',
        },
        {
          id: 45,
          name: 'high_290618',
          label: 'High_290618',
        },
        {
          id: 46,
          name: 'hodo',
          label: 'HODO',
        },
        {
          id: 47,
          name: 'low_050418',
          label: 'Low_050418',
        },
        {
          id: 48,
          name: 'low_100119',
          label: 'Low_100119',
        },
        {
          id: 49,
          name: 'low_230617',
          label: 'Low_230617',
        },
        {
          id: 50,
          name: 'low_251018',
          label: 'Low_251018',
        },
        {
          id: 51,
          name: 'low_290618',
          label: 'Low_290618',
        },
        {
          id: 52,
          name: 'medium_251018',
          label: 'Medium_251018',
        },
        {
          id: 53,
          name: 'medium_290618',
          label: 'Medium_290618',
        },
        {
          id: 54,
          name: 'meina',
          label: 'Meina',
        },
        {
          id: 55,
          name: 'monolith',
          label: 'monolith',
        },
        {
          id: 56,
          name: 'musclepharm exclusive',
          label: 'Musclepharm Exclusive',
        },
        {
          id: 57,
          name: 'pilot_010817',
          label: 'Pilot_010817',
        },
        {
          id: 58,
          name: 'purepremium',
          label: 'PurePremium',
        },
        {
          id: 59,
          name: 'redlemon',
          label: 'Redlemon',
        },
        {
          id: 60,
          name: 'shop',
          label: 'shop',
        },
        {
          id: 61,
          name: 'shop_sliders',
          label: 'shop_sliders',
        },
        {
          id: 62,
          name: 'side_gig',
          label: 'side_gig',
        },
        {
          id: 63,
          name: 'side_gig_sliders',
          label: 'side_gig_sliders',
        },
        {
          id: 64,
          name: 'smartwallaby',
          label: 'SmartWallaby',
        },
        {
          id: 65,
          name: 'starter',
          label: 'starter',
        },
        {
          id: 66,
          name: 'thrasio',
          label: 'THRASIO',
        },
        {
          id: 67,
          name: 'trial',
          label: 'Trial',
        },
        {
          id: 68,
          name: 'uk pilot programme plan',
          label: 'UK Pilot Programme Plan',
        },
        {
          id: 69,
          name: 'ultra_251018',
          label: 'Ultra_251018',
        },
        {
          id: 70,
          name: 'arehouse',
          label: 'arehouse',
        },
        {
          id: 71,
          name: 'warehouse_sliders',
          label: 'warehouse_sliders',
        },
      ].sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      }),
      filteredIntegration: [],
      url: '',
      filterName: '',
      noFilters: 0,
      savedFilters: [],
      filter: '',
      discounMonthPeriod: '',
      lastFiveCoupons: '',
      examplesDialog: '',
      workingGroups: [],
      workingGroupName: '',
      workingGroupDescription: '',
      workingGroupShopIds: [],
      selectedworkingGroup: '',
      chosenworkingGroup: '',
      integrations: [
        {
          id: 0,
          name: 'Google Merchant Centre',
          label: 'gmc',
        },
        {
          id: 1,
          name: 'Gorgias',
          label: 'gorgias',
        },
        {
          id: 2,
          name: 'Klaviyo',
          label: 'klaviyo',
        },
        {
          id: 3,
          name: 'Limestop',
          label: 'limestop',
        },
        {
          id: 4,
          name: 'LoyaltyLion',
          label: 'loyaltylion',
        },
        {
          id: 5,
          name: 'Omnisend',
          label: 'omnisend',
        },
        {
          id: 6,
          name: 'RiseAI',
          label: 'riseai',
        },
        {
          id: 7,
          name: 'SalesForce',
          label: 'salesforce',
        },
        {
          id: 8,
          name: 'Shopify Flow',
          label: 'flow',
        },
        {
          id: 9,
          name: 'SmileIO',
          label: 'smileio',
        },
        {
          id: 10,
          name: 'Wiser',
          label: 'wiser',
        },
        {
          id: 11,
          name: 'Zendesk',
          label: 'zendesk',
        },
      ],
      result: '',
      filters: {
        'shop': '',
        'plan': '',
        'spf': '',
        'mrr_option': '',
      },

    };
  },
};

</script>



<style>
.container {
  max-width: 95%;
}

.v-btn--disabled {
  cursor: not-allowed !important;
  pointer-events: revert;
}

.theme--dark.v-data-table {
  background-color: #131836;
  color: #ffffff;
}

.theme--dark.v-toolbar.v-sheet {
  background-color: #0d1024;
}

.title {
  /* background: #f6f7fc; */
  color: #3f51b5;
}

p.integrations-status {
  margin-bottom: 5px;
}

.table-link {
  cursor: pointer;
}

.v-btn__content {
  max-width: 100%;
}

.v-btn.red {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}

#app>div>main>div>div>div.container.grid-list-xl>div:nth-child(2)>div>div.flex.sm2.md2.background-color.dark>div>div>div>div.layout.row>div.flex.md3>input[type=number] {
  max-width: 50px;
  position: relative;
  top: 70px;
  right: 20px;
}

#app>div>main>div>div>div.container.grid-list-xl>div:nth-child(2)>div>div.flex.sm2.md2.background-color.dark>div>div>div>div.layout.row {
  position: relative;
  left: 10px;
}

#app>div.v-application--wrap>main>div>div>div.container.grid-list-xl>div:nth-child(2)>div>div.flex.sm2.md2.background-color.dark {
  border: darkblue;
  border: solid;
}

#app>div>main>div>div>div.container.grid-list-xl>div:nth-child(2)>div>div.flex.sm2.md2.background-color.dark {

  position: relative;
  left: 13px;
}

#app>div.v-application--wrap>main>div>div>div.container.grid-list-xl>div:nth-child(2)>div>div.flex.sm9.md9.background-color>div>div {

  position: relative;
  left: 60px;
}

#app>div>main>div>div>div.container.grid-list-xl>div:nth-child(2)>div>div.flex.sm9.md9.background-color>div>div>div.layout.row {

  width: 99%;
  position: relative;
  left: 16px;
}
</style>
